// Abas das configurações da empresa (negócio, equipe, perfil para IA, avisos).
import { NavLink } from 'react-router-dom'
import { useCan, useCompany } from '../../lib/company'

export default function CompanySettingsTabs() {
  const company = useCompany()
  const canEdit = useCan('company.edit_settings')
  const items = [
    { to: 'config/negocio', label: 'Seu negócio', show: canEdit },
    { to: 'config/equipe', label: 'Equipe', show: canEdit },
    { to: 'config/perfil-ia', label: 'Perfil para a IA', show: true },
    { to: 'config/avisos', label: 'Avisos', show: true },
  ].filter((i) => i.show)
  return (
    <nav className="tabs" aria-label="Configurações da empresa" style={{ marginBottom: 20, flexWrap: 'wrap' }}>
      {items.map((i) => (
        <NavLink key={i.to} to={`/app/${company.id}/${i.to}`} className={({ isActive }) => `tab ${isActive ? 'on' : ''}`}>{i.label}</NavLink>
      ))}
    </nav>
  )
}
